import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  visible: false,
  notificationList: [],
};

const slice = createSlice({
  initialState,
  name: "notification",
  reducers: {
    showNotification: (state) => {
      state.visible = true;
    },
    hideNotification: (state) => {
      state.visible = false;
    },
    getNotificationListSuccess: (state, action) => {
      state.notificationList = action.payload;
    },
  },
});

export const { showNotification, hideNotification, getNotificationListSuccess } = slice.actions;

export default slice.reducer;
